/// <amd-module name="Build/PipelinesLanguage/Utils/Yaml" />

import { parse, YAMLDocument } from "AzurePipelinesLanguageService";

export function yamlParse(text: string): YAMLDocument {
    return parse(removeEmojis(removePredirectives(text)));
}

// Emojis come in surrogate pairs, so we need to detect 2 characters.
// We may detect non-emoji characters with this regex, like international characters, but it's OK replacing those by whitespace as well.
const emojiRegex = /[\uD800-\uDFFF][\uD800-\uDFFF]/g;

export function removeEmojis(text: string) {
    return text.replace(emojiRegex, " ");
}

export function removePredirectives(text: string) {
    const lines = text.split("\n");
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        const indentLevel = getIndentationLevel(line);
        const trimmed = line.substring(indentLevel);
        // Find lines starting by ${{ (ignoring indentation)
        if (trimmed.startsWith("${{") || trimmed.startsWith("- ${{")) {
            // Replace ${{ lines by blank lines with spaces (to avoid changing char positions)
            lines[i] = " ".repeat(line.length);

            // Remove indentation, by adding the spaces to the end of the previous line in order to preserve char positions.
            let indentationGap = -1;
            for (let j = i + 1; j < lines.length; j++) {
                // Ignore blank or comment lines, but continue below until complete the scope.
                if (!isBlankOrComment(lines[j])) {
                    if (getIndentationLevel(lines[j]) > indentLevel) {
                        if (indentationGap < 0) {
                            // Calculate gap on the first non-blank line
                            indentationGap = getIndentationLevel(lines[j]) - indentLevel;
                        }

                        lines[j - 1] = lines[j - 1] + " ".repeat(indentationGap);
                        lines[j] = lines[j].substring(indentationGap);
                    } else {
                        break;
                    }
                }
            }
        }
    }

    return lines.join("\n");
}

function isBlankOrComment(line: string) {
    const trimmedLine = line?.trim();
    return !trimmedLine || trimmedLine.startsWith("#");
}

function getIndentationLevel(line: string) {
    if (!line) {
        return 0;
    }

    let j = 0;
    while (line[j] == " ") {
        j++;
    }

    return j;
}
